import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0c1275bb"
import script from "./sidebar.ts?vue&type=script&lang=ts&external"
export * from "./sidebar.ts?vue&type=script&lang=ts&external"
import style0 from "./sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports